/**
 * gameCode : lin, lin2, aion, bns, bnsr(프론티어 서버)
 * 
 * window.ncrwd = new nc.rwd.common({
        wstatic:'https://wstatic-cdn.plaync.com', 
        isLogin: true
    });
 * // 선물하기 팝업
 * window.ncrwd.ncoin.open( {gameCode}, {serverId}, {characterName} );
 * // 쿠폰 틍록/확인 팝업
 * window.ncrwd.ncoin.openCouponPop();
*/

export default class NcoinGift {
    constructor(_config){
        this.wstatic = _config.wstatic;
        this.isLogin = _config.isLogin;
    }

    open(_gameCode, _serverId, _characterName){
        if(!this.isLogin){
            window.GNBLogin();
            return false;
        }
        
        if(!userData.gameAccount?.name){
            if(confirm('대표 캐릭터 설정 후 N코인 선물하기가 가능합니다.')){
                window.cnb.openCharacterPan();
            }
            return false;
        }

        let params = {
            gameCode : _gameCode,
            serverId : _serverId,
            characterName : encodeURI(_characterName)
        };

        if (window.nshop?.popup) {
            this.openGiftPop(params);
        }else{
            let tag = document.createElement('script');
                tag.onload = () => this.openGiftPop(params);
                tag.src = `${this.wstatic}/nshop/common/popup/dist/js/popup-0.0.4-min.js`;
            document.head.appendChild(tag);
        }
    }

    openCouponPop(){
        if(!this.isLogin){
            window.GNBLogin();
            return false;
        }
        if (window.nshop?.popup) {
            nshop.popup({ popup_service:"NSHOP_COUPON" });
        }else{
            let tag = document.createElement('script');
                tag.onload = () => nshop.popup({ popup_service:"NSHOP_COUPON" });
                tag.src = `${this.wstatic}/nshop/common/popup/dist/js/popup-0.0.4-min.js`;
            document.head.appendChild(tag);
        }
    }

    openGiftPop(_params){
        nshop.popup({ popup_service:"NSHOP_GIFT", param: _params });
    }

} // end of class

/* 
 * N샵 팝업
    N샵 공통 Popup Guide: https://wiki.ncsoft.com/display/PTG/v0.0.4
    // JS import
    <script src="HOST/nshop/common/popup/dist/js/popup-0.0.4-min.js"></script>
    nshop.popup({ popup_service:"nshop_coupon"})
    nshop.popup({ popup_service:"NSHOP_GIFT", param: {"TEST_userID":"JOHN_guest1", "TEST_PARAM":"FOOBAR"} })
*/